module.exports = __webpack_public_path__ + "img/sc-video-title.8965fb08.png";